export default "__VITE_ASSET__f1a63f9f__"